import type { IMatrixLayout } from './IMatrixLayout';

const K = 'recordPage.viz.tows.';

/**
 * Матриця TOWS аналізу (прототип v4): «Зовнішні ↓ · Внутрішні →»; колонки «Сильні сторони · Слабкі сторони», рядки «Можливості ·
 * Загрози»; клітинки SO (зелені), WO і ST (бурштинові), WT (червонуваті) з приміткою-поясненням комбінації.
 */
export const TOWS_LAYOUT: IMatrixLayout = {
  field: 'combo', rowsAxis: `${K}external`, colsAxis: `${K}internal`, cols: [`${K}strengths`, `${K}weaknesses`], summary: `${K}summary`, skipArchived: false, keys: [],
  rows: [
    { key: 'opportunities', label: `${K}opportunities`, cells: [{ value: 'SO', tone: 'good', note: `${K}so` }, { value: 'WO', tone: 'mixed', note: `${K}wo` }] },
    { key: 'threats', label: `${K}threats`, cells: [{ value: 'ST', tone: 'mixed', note: `${K}st` }, { value: 'WT', tone: 'bad', note: `${K}wt` }] },
  ],
};
